<template>
  <b-modal
    :title="title"
    :content-class="pattern"
    :size="size"
    no-close-on-backdrop
    @hidden="$emit('hidden')"
    ref="modal"
  >
    <div slot="default">
      <div>
        <p v-html="bodyText"></p>
      </div>
    </div>
    <div slot="modal-footer">
      <b-button class="mt-3" variant="outline-danger" block @click="$emit('confirm')"
        >OK</b-button
      >
      <!-- <button type="button" class="btn btn-sm cancel" @click="onClose">
        Close
      </button> -->
    </div>
  </b-modal>
</template>

<script>
import { eventBus } from "@/main.js";
export default {
  name: "ModalConfirmDelete",
  props: {
    title: { type: String, default: "Delete" },
    size: { type: String, default: "md" },
    show: { type: Boolean, default: false },
    bodyText: { type: String, default: null },
  },
  data() {
    return {
      pattern: "danger",
      remark: "",
    };
  },
  watch: {
    show: function(value) {
      //console.log('show', value)
      if (value) {
        this.$refs.modal.show()
      } else this.$refs.modal.hide()
    },
  },
  methods: {
  },
};
</script>
<style>
.modal-content.no-content > .modal-body {
  display: none;
}
.modal-content > .modal-footer button {
  font-size: 12px;
}
/* danger */
.modal-content.danger > .modal-header {
  background-color: tomato;
  color: white;
}
.modal-content.danger > .modal-footer .confirm {
  background-color: tomato;
  color: white;
}
/* approve */
.modal-content.approve > .modal-header {
  background-color: olivedrab;
  color: white;
}
.modal-content.approve > .modal-footer .confirm {
  background-color: olivedrab;
  color: white;
}
/* confirm */
.modal-content.confirm > .modal-header {
  background-color: #556ee6;
  color: white;
}
.modal-content.confirm > .modal-footer .confirm {
  background-color: #556ee6;
  color: white;
}
/* info */
.modal-content.info > .modal-header {
  background-color: #17a2b8;
  color: white;
}
.modal-content.info > .modal-footer .confirm {
  background-color: #17a2b8;
  color: white;
}
</style>
